module.exports = __webpack_public_path__ + "img/v1-roadshow-preview.3737be49.png";